import {put} from 'redux-saga/effects';
import moment from 'moment';
import {selectSearchQueryParams} from '@computerrock/formation-router/sagas';
import * as contractPartnerActionTypes from '../contractPartnerActionTypes';
import contractPartnerScreenTabs from '../contractPartnerScreenTabs';
import config from '../../config';
import modalIds from '../../modalIds';

const loadCPQMFeedbackSearchResults = function* loadCPQMFeedbackSearchResults({payload}) {
    const {activeTab} = yield* selectSearchQueryParams();
    if (activeTab !== contractPartnerScreenTabs.QUALITY_MANAGEMENT) return;

    const {location, match} = payload;
    const searchQueryParams = new URLSearchParams(location.search);
    if (!searchQueryParams.get('sort')) searchQueryParams.append('sort', 'createdAt,desc');
    if (!searchQueryParams.get('createdAfter')) {
        searchQueryParams.append('createdAfter', moment().subtract(config.DEFAULT_TIME_PERIOD_IN_MONTHS, 'months').toISOString());
    }
    if (!searchQueryParams.get('createdBefore')) searchQueryParams.append('createdBefore', moment().toISOString());
    searchQueryParams.append('countries', [config.CONTRACT_PARTNERS_SEARCH_COUNTRY_CODE].join(', '));
    const {contractPartnerId} = match?.params;

    // do not reload qm feedback search results when agent opens a modal
    if (location && location.state?.isModalOpen
        && [modalIds.CP_CREATE_QUALITY_REPORT].includes(location.state?.modalId)
    ) return;

    yield put({
        type: contractPartnerActionTypes.SEARCH_CP_QUALITY_MANAGEMENT_FEEDBACKS,
        payload: {searchQueryParams, contractPartnerId},
    });
};

export default loadCPQMFeedbackSearchResults;
